<template>
    <div>
        <link rel="stylesheet" 
            href="https://use.fontawesome.com/releases/v5.2.0/css/all.css" 
            integrity="sha384-hWVjflwFxL6sNzntih27bfxkr27PmbbK/iSvJ+a4+0owXq79v+lsFkW54bOGbiDQ" 
            crossorigin="anonymous">

        <main>
            <div class="header">
                <div class="header-logo">
                    <router-link to="/landing" class="d-flex justify-content-center">
                        <img :src="require('../assets/images/horizontal_logo.png')" width="150px" height="30px">
                    </router-link>
                </div>
                <div class="bottom-item">
                    <a class="d-flex flex-column" @click="logout">
                        <inline-svg
                            :src="require('../assets/icon/logout.svg')"
                            width="32"
                            height="32"
                            aria-label="logout"
                        ></inline-svg>
                        <span>Logout</span>
                    </a>
                </div>
            </div>
            <div class="divider mb-5 mb-md-0 mb-lg-0">
                <!-- header -->
                <div class="sidebar" id="sidebar">
                    <div class="logo">
                        <router-link to="/landing" class="d-flex justify-content-center">
                            <img :src="require('../assets/images/savvix_logo.png')" >
                        </router-link>
                    </div>
                    
                    <b-nav vertical class="w-100">
                        <b-nav-item class="sidebar-item" to="/wallet">
                            <inline-svg
                                :src="require('../assets/icon/wallet.svg')"
                                width="30"
                                height="30"
                                aria-label="wallet"
                            ></inline-svg>
                            <span>Wallet</span>
                        </b-nav-item>

                        <b-nav-item v-if="userType == 'reuse'" class="sidebar-item" to="/request/history">
                            <inline-svg
                                :src="require('../assets/icon/transaction.svg')"
                                width="30"
                                height="30"
                                aria-label="transaction"
                            ></inline-svg>

                            <span>Request History</span>
                        </b-nav-item>

                        <b-nav-item class="sidebar-item" to="/transaction">
                            <inline-svg
                                :src="require('../assets/icon/transaction.svg')"
                                width="30"
                                height="30"
                                aria-label="swap"
                            ></inline-svg>

                            <span>Transaction</span>
                        </b-nav-item>

                        <b-nav-item v-if="viewOperator" class="sidebar-item" to="/operators">
                            <inline-svg
                                :src="require('../assets/icon/operators.svg')"
                                width="30"
                                height="40"
                                aria-label="operators"
                            ></inline-svg>
                            <span>Operators</span>
                        </b-nav-item>

                        <b-nav-item v-if="viewOperator" class="sidebar-item" to="/approve">
                            <inline-svg
                                :src="require('../assets/icon/operators.svg')"
                                width="30"
                                height="40"
                                aria-label="operators"
                            ></inline-svg>
                            <span>Approve</span>
                        </b-nav-item>

                        <b-nav-item class="sidebar-item" to="/profile">
                            <inline-svg
                                :src="require('../assets/icon/profile.svg')"
                                width="30"
                                height="40"
                                aria-label="profile"
                            ></inline-svg>
                            <span>Profile</span>
                        </b-nav-item>

                        <!-- <b-nav-item class="sidebar-item" to="/notification">
                            <inline-svg
                                :src="require('../assets/icon/bell.svg')"
                                width="30"
                                height="30"
                                aria-label="bell"
                            ></inline-svg>

                            <span>Notification</span>
                        </b-nav-item> -->

                        <b-nav-item class="sidebar-item" @click="logout">
                            <inline-svg
                                :src="require('../assets/icon/logout.svg')"
                                width="32"
                                height="32"
                                aria-label="logout"
                            ></inline-svg>

                            <span>Logout</span>
                        </b-nav-item>
                    </b-nav>
                </div>
                <router-view></router-view>

                <!-- <div id="menu" class="menu" @click="openMenu">
                    <i :class="icon"></i>
                </div> -->

                <!-- Bottom Navigation Bar -->
                <div class="bottom-bar">
                    <div class="bottom-item">
                        <router-link class="d-flex flex-column" to="/wallet">
                            <inline-svg
                                :src="require('../assets/icon/wallet.svg')"
                                width="30"
                                height="30"
                                aria-label="wallet"
                            ></inline-svg>
                            <span>Wallet</span>
                        </router-link>
                    </div>
                    <div v-if="userType == 'reuse'" class="bottom-item">
                        <router-link class="d-flex flex-column" to="/request/history">
                            <inline-svg
                                :src="require('../assets/icon/transaction.svg')"
                                width="30"
                                height="30"
                                aria-label="swap"
                            ></inline-svg>
                            <span>R. History</span>
                        </router-link>
                    </div>
                    <div class="bottom-item">
                        <router-link class="d-flex flex-column" to="/transaction">
                            <inline-svg
                                :src="require('../assets/icon/transaction.svg')"
                                width="30"
                                height="30"
                                aria-label="swap"
                            ></inline-svg>
                            <span>Transaction</span>
                        </router-link>
                    </div>
                    <div v-if="viewOperator" class="bottom-item">
                        <router-link class="d-flex flex-column" to="/operators">
                            <inline-svg
                                :src="require('../assets/icon/operators.svg')"
                                width="25"
                                height="30"
                                aria-label="operators"
                            ></inline-svg>
                            <span>Operators</span>
                        </router-link>
                    </div>
                    <div class="bottom-item">
                        <router-link class="d-flex flex-column" to="/profile">
                            <inline-svg
                                :src="require('../assets/icon/profile.svg')"
                                width="30"
                                height="30"
                                aria-label="profile"
                            ></inline-svg>
                            <span>Profile</span>
                        </router-link>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
import InlineSvg from "vue-inline-svg";
import api from '../helper/api.js';
import Swal from 'sweetalert2';

export default {
    name: 'Layout',
    components: {
        InlineSvg,
    },
    data () {
        return {
            menuTitle: 'open',
            menuOpened: false,
            icon: 'fas fa-bars',
            userType:localStorage.getItem('userType'),
            viewOperator:[localStorage.getItem('inviteOperator') ,localStorage.getItem('settingOperator'), localStorage.getItem('root')].includes('true')
        }
    },
    mounted() {
        console.log(this.viewOperator);
    },
    watch: {
        // $route () {
        //   if (window.getComputedStyle(document.getElementById('menu')).display === 'block') {
        //     document.getElementById('sidebar').style.display = 'none'
        //     this.menuTitle = 'open'
        //   }
        // }
    },
    methods: {
        openMenu () {
        if (this.menuTitle === 'close') {
            document.getElementById('sidebar').style.display = 'none';
            this.menuTitle = 'open'
        } else {
            document.getElementById('sidebar').style.display = 'block';
            this.menuTitle = 'close';
        }
        },
        async logout(){
            try{
                await api.apiCall("core","GET","/operators/logout");
                this.$router.push({name:'Login'});
                return
            }catch(error){
                console.log('baka ' + error)
                Swal.fire({
                    text: error.message,
                    icon: 'error'
                })
                return
            }
        }
    }
}
</script>

<style>
button:focus {
    outline: none;
}

.btn-secondary:focus, .btn-secondary.focus {
    box-shadow: none !important;
}

.divider .sidebar {
    display: none;
}

nav {
    margin: 0;
    height: 56px;
    padding: 0 16px 0 24px;
    color: #2c3e50;
    border-bottom: 1px solid rgba(0,0,0,0.4);
    flex-wrap: nowrap;
}

nav>span {
    display: block;
    position: relative;
    font-size: 20px;
    line-height: 1;
    letter-spacing: .02em;
    font-weight: 400;
    box-sizing: border-box;
    padding-top: 16px;
    float: right;
}

.divider {
    background: rgb(0, 0, 0, 0.05);
    margin-top: 70px;
}

.sidebar {
    background: #FFFFFF;
}

#sidebar ul.nav {
    display: flex;
    padding-left: 0;
    margin-bottom: 0;
    list-style: none;
    height: 400px;
    overflow: auto;
    flex-wrap: nowrap;
}

.logo {
    padding: 25px 0px;
}

.logo img {
    width: 60%;
    max-width: 150px;
}

/* .sidebar-item img {
    width: 35px;
    margin: 0px 8px;
} */

.sidebar-item a {
    display: flex;
    align-items: center;
    color: black;
    margin-left: 8%;
    height: 50px;
}

.sidebar svg {
    padding: 5px 0;
    width: 50px;
}

.sidebar-item a:hover, .router-link-exact-active, .router-link-active, 
.router-link-exact-active path, .router-link-active path, .router-link-active path .sidebar-item #sidebar_path,
.router-link-exact-active path .sidebar-item #sidebar_path path{
    background-color:rgba(0, 0, 0, 0.1);
    border-top-left-radius: 30px;
    border-bottom-left-radius: 30px;
    color: var(--second-text-color);
    text-decoration: none;
    fill: var(--primary) !important;
}

.router-link-exact-active > span{
    color: var(--second-text-color);
}

.sidebar-item a:hover path,
.sidebar-item a:hover #sidebar_path,
.sidebar-item a:hover #sidebar_path path {
    fill: var(--primary);
}

.sidebar-item #sidebar_path,
.sidebar-item #sidebar_path path{
    fill: var(--info-50);
}
.sidebar-item span {
    margin-left: 12px
}

.menu {
    font-size: 20px;
    padding: 12px;
    position: fixed;
    top: 0;
    right: 0;
    color: black;
}

.bottom-bar{
    position: fixed;
    background-color: white;
    bottom: 0;
    height: 60px;
    width: 100%;
    border-top-left-radius:12px;
    border-top-right-radius:12px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    z-index: 100;
    display: none;
}

.bottom-item{
    width: 20%;
    font-size: 12px;
}

.bottom-item a{
    align-items: center;
    color: #C1C1C1;
}

.header{
    position: fixed;
    top: 0;
    height: 70px;
    background-color: white;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 10px;
    z-index: 100;
    display: none;
}

@media only screen and (min-width: 768px) {
    .divider .sidebar {
        display: block;
    }
    .menu {
        display: none !important;
    }

    #sidebar ul.nav {
        height: auto;
    }

    .divider{
        margin: 0;
    }
}

@media only screen and (max-height: 600px) {
    #sidebar ul.nav {
        /* overflow: scroll; */
        height: 350px;
        flex-wrap: nowrap !important;
        scrollbar-width: none;
    }
}

@media only screen and (max-width: 450px){
    .bottom-bar{
        display: flex;
    }

    .sidebar-item a:hover, .router-link-exact-active, .router-link-active, 
    .router-link-exact-active path, .router-link-active path, .router-link-active path .sidebar-item #sidebar_path,
    .router-link-exact-active path .sidebar-item #sidebar_path path{
        background-color:transparent;
        border-top-left-radius: 30px;
        border-bottom-left-radius: 30px;
        color: var(--second-text-color);
        text-decoration: none !important;
        fill: var(--primary) !important;
    }

    .header{
        display: flex;
        justify-content: space-between;
    }
}
</style>